/* Glow Therapy · collection + search: live filters, sort, active pills, load more (Section Rendering API) */
(() => {
  'use strict';
  const GT = window.GT || {};
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const withSection = (url, sid) => { const u = new URL(url, location.href); u.searchParams.set('section_id', sid); return u; };
  const clean = (url) => { const u = new URL(url, location.href); u.searchParams.delete('section_id'); return u.pathname + u.search; };
  const after = (root) => {
    root.querySelectorAll('[data-rail]').forEach((r) => GT.initRail && GT.initRail(r));
    GT.syncSaved && GT.syncSaved();
  };

  const queryFrom = (form) => {
    const p = new URLSearchParams();
    for (const [k, v] of new FormData(form).entries()) { if (String(v).trim() !== '') p.append(k, v); }
    return p.toString();
  };

  const init = (root) => {
    if (!root || root.dataset.facetsReady) return;
    root.dataset.facetsReady = '1';
    const sid = root.dataset.sectionId;
    let ctrl;

    const swap = async (url) => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      root.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(withSection(url, sid), { signal: ctrl.signal });
        const doc = parse(await res.text());
        const openIds = Array.from(root.querySelectorAll('[data-facet-group][open]')).map((d) => d.id);
        const focusId = document.activeElement && root.contains(document.activeElement) ? document.activeElement.id : '';
        doc.querySelectorAll('[data-facets-swap]').forEach((n) => {
          const cur = root.querySelector(`[data-facets-swap="${n.dataset.facetsSwap}"]`);
          if (cur) cur.innerHTML = n.innerHTML;
        });
        const freshSort = doc.querySelector('select[name="sort_by"]');
        const sort = root.querySelector('select[name="sort_by"]');
        if (freshSort && sort) sort.value = freshSort.value;
        openIds.forEach((id) => { const d = document.getElementById(id); if (d) d.open = true; });
        if (focusId) { const f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); }
        history.replaceState(history.state, '', clean(url));
        after(root);
      } catch (err) {
        if (err.name !== 'AbortError') location.href = url;
      } finally {
        root.removeAttribute('aria-busy');
      }
    };

    const form = root.querySelector('[data-facets-form]');
    const submit = () => { if (!form) return; const q = queryFrom(form); swap(`${form.getAttribute('action')}${q ? `?${q}` : ''}`); };
    const sortEl = root.querySelector('select[name="sort_by"]');

    root.addEventListener('change', (e) => {
      if (!e.target.matches('[data-facets-input]')) return;
      if (form) submit();
      else if (e.target === sortEl) { const u = new URL(location.href); u.searchParams.set('sort_by', sortEl.value); u.searchParams.delete('page'); swap(u.toString()); }
    });
    form && form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });

    root.addEventListener('click', async (e) => {
      const link = e.target.closest('[data-facets-link]');
      if (link) { e.preventDefault(); swap(link.href); return; }
      const more = e.target.closest('[data-load-more]');
      if (!more) return;
      e.preventDefault();
      if (more.getAttribute('aria-busy') === 'true') return;
      more.setAttribute('aria-busy', 'true');
      const label = more.textContent;
      more.textContent = 'Loading more picks';
      try {
        const doc = parse(await (await fetch(withSection(more.href, sid))).text());
        const grid = root.querySelector('[data-facets-grid]');
        const fresh = doc.querySelector('[data-facets-grid]');
        let first = null;
        if (grid && fresh) Array.from(fresh.children).forEach((c) => { if (!c.matches('[data-insert]')) { grid.appendChild(c); first = first || c; } });
        const moreBox = root.querySelector('[data-facets-swap="more"]');
        const freshMore = doc.querySelector('[data-facets-swap="more"]');
        if (moreBox && freshMore) moreBox.innerHTML = freshMore.innerHTML;
        history.replaceState(history.state, '', clean(more.href));
        after(root);
        const a = first && first.querySelector('a[href]');
        if (a) a.focus({ preventScroll: true });
      } catch (err) {
        location.href = more.href;
      } finally {
        more.removeAttribute('aria-busy');
        if (more.isConnected) more.textContent = label;
      }
    });

    /* desktop: close dropdown chips on outside click / Escape; drawer semantics only on small screens */
    document.addEventListener('click', (e) => {
      root.querySelectorAll('[data-facet-group][open]').forEach((d) => { if (window.matchMedia('(min-width: 1100px)').matches && !d.contains(e.target)) d.open = false; });
    });
    root.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const d = e.target.closest('[data-facet-group][open]');
      if (d && window.matchMedia('(min-width: 1100px)').matches) { d.open = false; d.querySelector('summary').focus(); }
    });
    /* phone/tablet: "Show N picks" closes the drawer (theme.js) and brings the results into view */
    root.addEventListener('click', (e) => {
      if (!e.target.closest('.cf-drawer__foot .gt-btn--primary')) return;
      const bar = root.querySelector('.cf-bar');
      if (bar) setTimeout(() => bar.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }), 60);
    });
    const drawer = root.querySelector('#FilterDrawer');
    if (drawer) {
      const mq = window.matchMedia('(min-width: 1100px)');
      const sync = () => {
        if (mq.matches) { drawer.removeAttribute('role'); drawer.removeAttribute('aria-modal'); drawer.removeAttribute('tabindex'); drawer.setAttribute('aria-label', 'Filters'); }
        else { drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true'); drawer.setAttribute('tabindex', '-1'); drawer.removeAttribute('aria-label'); }
      };
      mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
      sync();
    }
  };

  document.querySelectorAll('[data-facets]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-facets]').forEach(init));
})();
